'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _interopRequireDefault = function (obj) { return obj && obj.__esModule ? obj : { 'default': obj }; };

var _assign = require('./utils/Object.assign');

var _assign2 = _interopRequireDefault(_assign);

var _deprecationWarning = require('./utils/deprecationWarning');

var _deprecationWarning2 = _interopRequireDefault(_deprecationWarning);

var _CollapsibleMixin = require('./CollapsibleMixin');

var _CollapsibleMixin2 = _interopRequireDefault(_CollapsibleMixin);

var link = 'https://github.com/react-bootstrap/react-bootstrap/issues/425#issuecomment-97110963';

var CollapsableMixin = _assign2['default']({}, _CollapsibleMixin2['default'], {
  getCollapsableClassSet: function getCollapsableClassSet(className) {
    _deprecationWarning2['default']('CollapsableMixin.getCollapsableClassSet()', 'CollapsibleMixin.getCollapsibleClassSet()', link);
    return _CollapsibleMixin2['default'].getCollapsibleClassSet.call(this, className);
  },

  getCollapsibleDOMNode: function getCollapsibleDOMNode() {
    _deprecationWarning2['default']('CollapsableMixin.getCollapsableDOMNode()', 'CollapsibleMixin.getCollapsibleDOMNode()', link);
    return this.getCollapsableDOMNode();
  },

  getCollapsibleDimensionValue: function getCollapsibleDimensionValue() {
    _deprecationWarning2['default']('CollapsableMixin.getCollapsableDimensionValue()', 'CollapsibleMixin.getCollapsibleDimensionValue()', link);
    return this.getCollapsableDimensionValue();
  },

  componentDidMount: function componentDidMount() {
    _deprecationWarning2['default']('CollapsableMixin', 'CollapsibleMixin', link);
  }
});

exports['default'] = CollapsableMixin;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-bootstrap/lib/CollapsableMixin.js
 ** module id = 211
 ** module chunks = 0
 **/